import React from 'react';
export const CourseCard = ({
  id,
  tutor,
  thumbnail,
  subCategory,
  title,
  handleViewClick, 
}) => {
  const handleCardClick = () => {
    handleViewClick(id); 
  };

  return (
    <div
      className="bg-white p-3 rounded-md cursor-pointer flex shadow-sm flex-col gap-2"
      key={id}
      onClick={handleCardClick} // Trigger the click event with the id
    >
      <div className="rounded-lg relative">
        <img
          src={thumbnail}
          alt="course-img"
          className="h-[113px] w-full object-cover rounded-lg"
        />
           <button className="bg-primary absolute bottom-3 left-2 w-fit px-2 py-1 text-blueColor text-[8px] font-medium rounded-sm">
        {subCategory}
      </button>
      </div>
   
      <p className="font-semibold text-[14px] leading-[20px]">{title}</p>
      <div className="flex w-full justify-between items-center gap-2">
        <div className="w-[80%] bg-lightYellow h-[6px]">
          <div className={` h-full bg-primary`} style={{ width: "70%" }}></div>
          {/* <div className={` h-full ${rateBg}`} style={{ width: `${rate}%` }}></div> */}
        </div>
        <p className="text-blueColor font-bold text-[11px] leading-[16px]">70%</p>
      </div>
      <div className="flex gap-4">
        <div>
          <div className="w-6 h-6 rounded-full">
            <img
              src="https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg"
              alt="profile"
              className="w-full h-full object-cover rounded-full"
            />
          </div>
        </div>
        <div className="flex flex-col justify-between text-[8px]">
          <h2 className="text-neutral font-semibold">{tutor}</h2>
          <p>Tutor</p>
        </div>
      </div>
    </div>
  );
};
